import React, { useState } from "react";
import { AsYouType, parsePhoneNumber, validatePhoneNumberLength } from "libphonenumber-js";
import { Form } from "react-final-form";
import { Text } from "../../../../common/components/input/Text";
import { Error as InputError } from "../../../copy/input";
import { Button } from "@truevault/aquilo";
import { CircularProgress } from "@mui/material";

export const MultiFactorAuthSetup = ({
  setPhone,
  createMfaChallenge,
  isLoading,
}: {
  setPhone: (phone: string) => void;
  createMfaChallenge: (phone: string) => Promise<void>;
  isLoading: boolean;
}) => {
  const [tempPhone, setTempPhone] = useState("");
  return (
    <>
      <div className="text-center fill">
        <p className="mt-sm mb-lg">Enter a mobile phone number to use for SMS verification.</p>
      </div>

      <Form
        onSubmit={({ phone }) => {
          setPhone(phone);
          createMfaChallenge(phone);
        }}
        validate={validatePhoneNumber}
        render={(props) => (
          <form className="flex-col fill" onSubmit={props.handleSubmit}>
            <div className="flex-col fill">
              <div className="flex-row flex--expand mb-0">
                <Text
                  className="m-0 w-300"
                  fullWidth={false}
                  multiline={false}
                  variant="outlined"
                  autoComplete="off"
                  name="phone"
                  field="phone"
                  type="tel"
                  size="small"
                  value={tempPhone}
                  onChange={(e) => {
                    let newValue = e.target.value;
                    if (tempPhone.endsWith(")") && newValue.length < tempPhone.length) {
                      newValue = newValue.slice(0, -1);
                    }
                    setTempPhone(new AsYouType("US").input(newValue));
                  }}
                  required
                />
              </div>
              <div className="tw-boundary">
                <div className="w-[300px] mt-[24px]">
                  <Button
                    onClick={props.handleSubmit}
                    color="primary"
                    disabled={Boolean(!props.values?.phone || props.errors?.phone)}
                    width="full"
                  >
                    {isLoading ? (
                      <CircularProgress size={20} color="secondary" />
                    ) : (
                      "Send code via SMS"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </form>
        )}
      />
    </>
  );
};

const validatePhoneNumber = (values) => {
  const errors = {} as any;
  if (values.phone) {
    try {
      if (!parsePhoneNumber(values.phone, "US") || validatePhoneNumberLength(values.phone, "US")) {
        errors.phone = InputError.InvalidPhone;
      }
    } catch (e) {
      errors.phone = InputError.InvalidPhone;
    }
  }
  return errors;
};
